import { Dispatch } from 'react';

import {
  ApiAction,
  getErrorAction,
  getLoadingAction,
  getSuccessAction,
} from '../api-actions';
import { Store } from '../../domain/Store';
import { getmenuandstore } from '../../api/store';

export const getStoresThunk = async (dispatch: Dispatch<ApiAction>) => {
  try {
    dispatch(getLoadingAction());
    const stores: Store[] = await getmenuandstore('MENU', false);
    dispatch(getSuccessAction(stores));
  } catch (error: any) {
    if (!error.__CANCEL__) {
      dispatch(getErrorAction(error));
    }
  }
};
